import React, { Component } from "react";
import AdminComponent from './components/AdminComponent';

import PropTypes from 'prop-types';


export class AdminContainer extends Component {
    constructor (props){
        super(props)
        this.state = {
            // set any states we need for the Services page
            sidePannel:'closed',
            subTab:'',
        }
        this.updateSidePannel = this.updateSidePannel.bind(this);
        this.updateSubTab = this.updateSubTab.bind(this);
    }

    updateSidePannel(selected){
        this.setState({sidePannel:selected});
    }
    updateSubTab(selected){
        this.setState({subTab:selected});
    }


    render(){
        return(
            <AdminComponent 
                tab={this.props.tab} updateTab={this.props.updateTab} 
                sidePannel={this.state.sidePannel} updateSidePannel={this.updateSidePannel}
                subTab={this.state.subTab} updateSubTab={this.updateSubTab}
            />
        )
    }
          
        
}

AdminContainer.defaultProps={

}
AdminContainer.propTypes = {
    tab: PropTypes.string,
    updateTab:PropTypes.func,
}

export default(AdminContainer);